// PickupUserPreferences — handles the customer's preferred pickup location.

// POST the customer's preferred pickup location to the preferences app, then mirror it on the Klaviyo profile.
async function updatePreferredPickupLocation(storeHandle) {
  const response = await fetch(KROWN.settings.api_urls.preferences_app_url + '/pickup-location/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      storeHandle: storeHandle,
    }),
  });

  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}: ${response.statusText}`);
  }

  const result = await response.json();

  if (typeof window.syncKlaviyoProfileProperties === 'function') {
    await window.syncKlaviyoProfileProperties(['preferred_pickup_location']);
  }

  return result;
}

// Remove the saved preferred location. null tells the preferences app to store an empty list.
function clearPreferredPickupLocation() {
  return updatePreferredPickupLocation(null);
}

// Get the default pickup handle from the customer's preferred pickup locations.
function getDefaultPickupHandle() {
  const prefs = PickupContext.preferredPickupLocations;
  return prefs && prefs.length > 0 ? prefs[0] : null;
}

window.PickupUserPreferences = {
  updatePreferredPickupLocation,
  clearPreferredPickupLocation,
  getDefaultPickupHandle,
};
